import { UseCase } from "../../useCase"
import { CreateSurveySectionResponse } from "./response"
import { CreateSurveySectionRequest } from "./request"
import { SurveyRepository } from "../../../repositories/surveyRepository"

export class CreateSurveySectionUseCase implements UseCase<CreateSurveySectionRequest, CreateSurveySectionResponse> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec(surveySection: CreateSurveySectionRequest) {
		return this._repository.createSurveySection(surveySection)
	}
}
